import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceExportDataNotificationState = createStateReducer(initialState, {
  [events.exportDataFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "exportData",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceExportDataNotificationState };
